import React from 'react';

export const ConfigDone = () => {
	return (
		<svg width="300" height="161" viewBox="0 0 300 161" fill="none">
			<g clipPath="url(#clip0_10799_21872)">
				<path d="M148 38.5L148 49.5" stroke="#D6D6D6" strokeWidth="2" />
				<path
					d="M64.3464 151.549H218.972C218.972 151.549 222.431 128.09 211.601 117.13C197.312 102.728 164.366 95.7539 156.904 72.7475C149.441 49.7411 108.85 47.0238 90.5573 66.4072C72.2643 85.7905 93.1056 94.4858 68.1688 111.424C43.2321 128.361 64.3464 151.549 64.3464 151.549Z"
					fill="#EBEBEB"
				/>
				<rect
					x="138.564"
					y="65.4898"
					width="34.8679"
					height="34.8679"
					rx="3.5"
					transform="rotate(-20 138.564 65.4898)"
					fill="white"
					stroke="#D6D6D6"
				/>
				<rect
					x="141.308"
					y="66.7664"
					width="30.5932"
					height="30.5932"
					rx="4"
					transform="rotate(-20 141.308 66.7664)"
					fill="#F4F4F4"
				/>
				<rect
					x="108.948"
					y="24.0711"
					width="34.8679"
					height="34.8679"
					rx="3.5"
					transform="rotate(8.86885 108.948 24.0711)"
					fill="white"
					stroke="#D6D6D6"
				/>
				<rect
					x="110.731"
					y="26.5125"
					width="30.5932"
					height="30.5932"
					rx="4"
					transform="rotate(8.86885 110.731 26.5125)"
					fill="#F4F4F4"
				/>
				<path
					d="M122.182 35.2392L124.267 35.5645L121.664 52.2417L115.41 51.2658L122.182 35.2392Z"
					fill="#D6D6D6"
				/>
				<path
					d="M127.393 36.0523L125.309 35.727L122.706 52.4042L128.96 53.3801L127.393 36.0523Z"
					fill="#D6D6D6"
				/>
				<path
					d="M116.32 38.5952L131.955 41.0349L131.305 45.2042L115.67 42.7645L116.32 38.5952Z"
					fill="#D6D6D6"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M130.75 41.9145L117.2 39.8002L116.875 41.8848L130.425 43.9992L130.75 41.9145ZM116.32 38.5952L115.67 42.7645L131.305 45.2042L131.955 41.0349L116.32 38.5952Z"
					fill="#F4F4F4"
				/>
				<path
					d="M93.8863 94.8337C92.9658 92.2308 94.8965 89.5 97.6574 89.5H202.463C205.19 89.5 207.117 92.1679 206.261 94.7564L188.396 148.756C187.854 150.394 186.323 151.5 184.598 151.5H116.755C115.06 151.5 113.549 150.432 112.984 148.834L93.8863 94.8337Z"
					fill="white"
				/>
				<path
					d="M143.4 101.694C143.514 105.558 146.516 108.605 150.104 108.498C153.693 108.392 156.509 105.173 156.394 101.309"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<rect x="121" y="103.5" width="12" height="6" rx="3" fill="#ffcc00" />
				<rect x="167" y="103.5" width="12" height="6" rx="3" fill="#ffcc00" />
				<circle cx="131" cy="102.5" r="4" fill="#A6A6A6" />
				<circle cx="169" cy="102.5" r="4" fill="#A6A6A6" />
				<path
					d="M94.8291 94.5003C94.1387 92.5481 95.5867 90.5 97.6574 90.5H202.463C204.508 90.5 205.954 92.5009 205.312 94.4423L187.446 148.442C187.04 149.671 185.892 150.5 184.598 150.5H116.755C115.484 150.5 114.351 149.699 113.927 148.5L94.8291 94.5003Z"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M123 64.5C123 60.634 126.134 57.5 130 57.5H170C173.866 57.5 177 60.634 177 64.5V90.5H123V64.5Z"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<rect x="139" y="54.5" width="23" height="7" rx="3" fill="#ffcc00" stroke="#A6A6A6" strokeWidth="2" />
				<path d="M106 150.5H196" stroke="#A6A6A6" strokeWidth="1.96721" />
				<g style={{ mixBlendMode: 'multiply' }}>
					<path d="M150.5 149.5C130.5 135 123.5 122 123.5 91H94.5L114 149.5H150.5Z" fill="#F6F6F6" />
				</g>
				<path d="M161 25.5L161.085 30.4993" stroke="#D6D6D6" strokeWidth="2" />
				<path d="M161.133 33.499L161.37 47.497" stroke="#D6D6D6" strokeWidth="2" />
				<path d="M134 16.5L134 23.5" stroke="#D6D6D6" strokeWidth="2" />
				<path d="M120 0.5L120 15.5" stroke="#D6D6D6" strokeWidth="2" />
				<path d="M134 10.5V14" stroke="#D6D6D6" strokeWidth="2" />
				<path
					d="M203.928 70.1624C204.177 69.8517 204.492 69.6009 204.851 69.4286C205.21 69.2562 205.602 69.1667 206 69.1667C206.398 69.1667 206.791 69.2562 207.15 69.4286C207.508 69.6009 207.824 69.8517 208.072 70.1624L210.535 73.2273C210.814 73.5749 211.177 73.8464 211.589 74.0169C212.001 74.1874 212.449 74.2513 212.892 74.2028L216.801 73.7772C217.195 73.7352 217.594 73.782 217.968 73.9144C218.343 74.0467 218.682 74.2612 218.963 74.542C219.243 74.8228 219.457 75.1629 219.589 75.5372C219.72 75.9115 219.767 76.3106 219.724 76.7051L219.298 80.6116C219.25 81.0549 219.314 81.5033 219.485 81.9152C219.656 82.3272 219.928 82.6896 220.275 82.9688L223.339 85.4297C223.649 85.6785 223.9 85.9939 224.072 86.3525C224.244 86.7111 224.334 87.1039 224.334 87.5017C224.334 87.8995 224.244 88.2922 224.072 88.6509C223.9 89.0095 223.649 89.3249 223.339 89.5737L220.275 92.0361C219.928 92.315 219.656 92.6771 219.485 93.0888C219.314 93.5005 219.25 93.9487 219.298 94.3918L219.724 98.2999C219.767 98.6947 219.721 99.0941 219.589 99.4688C219.457 99.8434 219.243 100.184 218.962 100.465C218.681 100.745 218.341 100.96 217.966 101.091C217.592 101.223 217.192 101.269 216.797 101.226L212.889 100.801C212.446 100.753 211.998 100.817 211.586 100.988C211.174 101.159 210.811 101.43 210.532 101.778L208.072 104.838C207.824 105.148 207.508 105.399 207.15 105.572C206.791 105.744 206.398 105.833 206 105.833C205.602 105.833 205.21 105.744 204.851 105.572C204.492 105.399 204.177 105.148 203.928 104.838L201.469 101.774C201.189 101.427 200.827 101.155 200.415 100.985C200.003 100.814 199.555 100.749 199.111 100.797L195.203 101.223C194.808 101.266 194.409 101.22 194.034 101.088C193.66 100.956 193.319 100.742 193.038 100.461C192.757 100.181 192.543 99.8403 192.411 99.4656C192.28 99.091 192.234 98.6915 192.277 98.2967L192.702 94.3886C192.751 93.9455 192.686 93.4974 192.516 93.0856C192.345 92.6739 192.073 92.3118 191.725 92.0329L188.662 89.5737C188.351 89.3249 188.101 89.0095 187.929 88.6509C187.756 88.2922 187.667 87.8995 187.667 87.5017C187.667 87.1039 187.756 86.7111 187.929 86.3525C188.101 85.9939 188.351 85.6785 188.662 85.4297L191.725 82.9688C192.073 82.6896 192.345 82.3272 192.516 81.9152C192.686 81.5033 192.751 81.0549 192.702 80.6116L192.277 76.7051C192.234 76.3103 192.28 75.9109 192.412 75.5363C192.544 75.1617 192.758 74.8215 193.039 74.5406C193.32 74.2597 193.66 74.0453 194.034 73.9132C194.409 73.7811 194.808 73.7346 195.203 73.7772L199.111 74.2028C199.555 74.2513 200.003 74.1874 200.415 74.0169C200.827 73.8464 201.189 73.5749 201.469 73.2273L203.928 70.1624Z"
					fill="#ffcc00"
				/>
				<path
					d="M211.857 83.8333L205.081 91.6448C205.031 91.7119 204.967 91.7674 204.893 91.8075C204.819 91.8477 204.738 91.8716 204.654 91.8776C204.571 91.8836 204.487 91.8716 204.408 91.8424C204.33 91.8131 204.258 91.7674 204.199 91.7082L200.5 88.0087"
					stroke="#3D3D3D"
					strokeWidth="2"
					strokeLinejoin="round"
				/>
				<path
					d="M159.058 68.2555L162.392 71.7946L165.908 70.5149C166.083 70.4439 166.276 70.4286 166.46 70.4713C166.644 70.5139 166.811 70.6123 166.937 70.7531C167.063 70.894 167.143 71.0703 167.165 71.2581C167.188 71.4459 167.152 71.6361 167.063 71.8026L165.001 75.6361L168.109 78.9154C168.248 79.0665 168.337 79.2574 168.362 79.4613C168.387 79.6651 168.347 79.8716 168.249 80.0518C168.15 80.2319 167.998 80.3765 167.813 80.4654C167.628 80.5542 167.42 80.5828 167.218 80.5471L162.295 79.7283L159.049 83.5205C158.917 83.6791 158.739 83.7923 158.54 83.844C158.341 83.8956 158.13 83.8832 157.938 83.8084C157.746 83.7337 157.583 83.6004 157.471 83.4274C157.358 83.2544 157.304 83.0506 157.314 82.8447L157.591 78.3347L153.548 76.7243C153.371 76.6548 153.221 76.5324 153.117 76.3739C153.013 76.2154 152.96 76.0287 152.966 75.8391C152.972 75.6496 153.036 75.4667 153.15 75.3153C153.264 75.164 153.422 75.0516 153.603 74.9937L157.124 73.7118L157.406 68.8567C157.432 68.6784 157.506 68.5105 157.62 68.3709C157.734 68.2313 157.883 68.125 158.053 68.0634C158.222 68.0019 158.405 67.9872 158.581 68.021C158.758 68.0548 158.923 68.1358 159.058 68.2555Z"
					fill="#D6D6D6"
				/>
			</g>
			<defs>
				<clipPath id="clip0_10799_21872">
					<rect width="300" height="160" fill="white" transform="translate(0 0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
